import React from 'react'
import { DefaultCopyField } from '@eisberg-labs/mui-copy-field';

export default function UiCopyField(props) {
    const { label, value } = props;

    return (
        <>
            <DefaultCopyField
                label={label}
                value={value} />

        </>
    )
}
